import { Grid, GridProps } from '@mui/material';

export function Row({ sx, ...props }: GridProps) {
    return (
        <Grid
            container
            spacing={2}
            sx={{
                mb: 2,
                flexDirection: {
                    xs: 'column',
                    lg: 'row',
                },
                ...sx,
            }}
            {...props}
        />
    );
}
